<div class="animated fadeInRight">
  <!-- MENU DE TITULOS -->
  <app-lfsa-card-v2 [innTemplateButton]="innTemplateButton" [innTemplate]="enviarTemplateEdit"
                    [modulo]="DAT_TITULOS.modulo" [tituloCard]="DAT_TITULOS.tituloCardListar"
                    [titulo]="DAT_TITULOS.titulo">
  </app-lfsa-card-v2>
  <!-- MENU DE TITULOS -->

  <!-- OPCIONES LATERAL IZQUIERDO -->
  <ng-template #innTemplateButton>
    <div class="col-md-6 mb-2">
      <div class="pagetitle">
        <div class="btn-group-justified btn-group" style="float: right;">
          <button (click)="nueva()" class="btn btn-outline-success">
            <i aria-hidden="true" class="fa fa-plus"></i>
            {{DAT_BTNS.agregar}}
          </button>
        </div>
      </div>
    </div>
  </ng-template>
  <!-- OPCIONES LATERAL IZQUIERDO -->

  <!-- GRILLA -->
  <ng-template #enviarTemplateEdit>
    <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
    <ag-grid-angular #agGrid (gridReady)="onGridReady($event)" [class]="DAT_AG_GRID.class" [columnDefs]="columnDefs"
                     [floatingFilter]="true" [frameworkComponents]="frameworkComponents" [id]="DAT_AG_GRID.id"
                     [ngStyle]="DAT_AG_GRID.style" [paginationPageSize]="DAT_AG_GRID.paginacion"
                     [pagination]="true"
                     [rowData]="rowData">
      [rowSelection]="'single'"
    </ag-grid-angular>
  </ng-template>
  <!-- GRILLA -->
</div>

<!-- MODAL -->
<app-lfsa-modal [idButton]="'abrirModal'" [idClose]="'cerrarModal'" [innTemplate]="abrirModalOrdenReferencia"
                [titulo]="tituloModal"></app-lfsa-modal>
<ng-template #abrirModalOrdenReferencia>
  <div class="container-fluid">
    <form [formGroup]="formOrdernes" class="row" mat-dialog-content>
      <div class="col-lg-5 mb-2">
        <label for="">Orden N#</label>
        <input class="form-control" formControlName="numOrd" name="numOrd" type="text">
      </div>
      <div class="col-lg-7 mb-2">
        <label for="">Fecha</label>
        <input class="form-control" formControlName="fechaOrd" name="fechaOrd" type="text">
      </div>
      <div class="col-lg-12 mb-2">
        <label for="">Material</label>
        <div class="row">
          <div class="col-lg-5">
            <div class="d-flex">
              <input autocomplete="off" class="form-control" formControlName="material" name="material" type="text">
              <button (click)="searchMaterial()" [disabled]="formOrdernes.controls['material'].errors"
                      class="btn btn-success ms-2">Buscar
              </button>
            </div>
            <div
              *ngIf="formOrdernes.controls['material'].invalid && (formOrdernes.controls['material'].dirty || formOrdernes.controls['material'].touched)"
              class="text-danger">
              <small>
                <div *ngIf="formOrdernes.controls['material'].errors">
                  El campo es requerido.
                </div>
              </small>
            </div>
          </div>
          <div class="col-lg-7">
            <input class="form-control" formControlName="materialDescripcion" name="desca" type="text">
          </div>
        </div>
      </div>
      <div class="col-lg-4 mb-3">
        <label for="">Cantidad</label>
        <input autocomplete="off" class="form-control" formControlName="cantidad" name="cantidad" type="number">
        <small *ngIf="cantidad?.hasError('required') && cantidad?.touched" class="text-danger">*Este campo es
          requerido</small>
      </div>
      <app-lfsa-botones-formulario (devolverAccion)="acciones( $event )" [formularioValido]="formOrdernes.invalid"
                                   [loading]="loading" [textBoton]="'Guardar'"
                                   class="row">
      </app-lfsa-botones-formulario>
    </form>
  </div>
</ng-template>
<!-- END MODAL -->
